import React from 'react';
import { SeraForm } from './SeraForm';
import { SeraReviewProvider } from './context';

export const SeraReview: React.FC = () => (
	<SeraReviewProvider>
		<SeraForm />
	</SeraReviewProvider>
);
